<template>
  <div class="vip-detail-refund-order">
    <el-row :gutter="20" class="margin-bottom">
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="vipDetailRefundOrderInfo.orders" border style="width: 100%" v-loading="loading">
        <el-table-column prop="cartId" :label="$t('vipDetailRefundOrder.orderNo')" align="center"
          width="180"></el-table-column>
        <el-table-column prop="prodName" :label="$t('vipDetailRefundOrder.productName')" align="center"
          ></el-table-column>
        <el-table-column prop="specValue" :label="$t('vipDetailRefundOrder.productSpec')" align="center"
          width="150"></el-table-column>
        <el-table-column prop="personName" :label="$t('vipDetailRefundOrder.userName')" align="center"
          ></el-table-column>
        <el-table-column prop="returnPayPrice" :label="$t('vipDetailRefundOrder.refundAmount')" align="center"
          width="120"></el-table-column>
        <el-table-column prop="stateName" :label="$t('vipDetailRefundOrder.orderStatus')" align="center"
          width="120"></el-table-column>
        <el-table-column prop="returnReason" :label="$t('vipDetailRefundOrder.refundReason')" align="center"
         ></el-table-column>
        <el-table-column prop="createTime" :label="$t('vipDetailRefundOrder.applyTime')" align="center"
         ></el-table-column>
      </el-table>

      <el-pagination class="margin-top" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    </div>
  </div>
</template>

<script>
import { getShopRefundOrders } from '@/api/user/vipDetailApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'VipDetailRefundOrder',
  data() {
    return {
      vipDetailRefundOrderInfo: {
        orders: [],
        link: ''
      },
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
  },
  methods: {
    open(data) {
      this.vipDetailRefundOrderInfo.link = data.tel
      this.loadRefundOrderData()
    },
    loadRefundOrderData() {
      if (!this.vipDetailRefundOrderInfo.link) return

      this.loading = true
      const params = {
        link: this.vipDetailRefundOrderInfo.link,
        shopId: this.shopId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }

      getShopRefundOrders(params)
        .then(res => {
          this.vipDetailRefundOrderInfo.orders = res.data
          this.pagination.total = res.records
          this.loading = false
        })
        .catch(err => {
          console.error('获取退款订单数据失败:', err)
          this.loading = false
        })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadRefundOrderData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadRefundOrderData()
    }
  }
}
</script>

<style scoped>
.vip-detail-refund-order {
  
}

.margin-bottom {
  margin-bottom: 20px;
}

.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>